import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultiTierHierarchyService {

  baseHref = environment.baseHref;

  constructor(
    private http: HttpClient,
  ) { }

  saveOrUpdatePolicyData(payload) {
    return this.http.post<any>(this.baseHref + '/saveOrUpdatePolicyData', payload);
  }

  getOrgPolicyData(brandId, supplierId) {

    const params=new HttpParams()
    .set('parentId', brandId) 
    .set('childId', supplierId)


    return this.http.get<any>(this.baseHref + '/getOrganizationPolicyData', { params });
  }

}
